import Vue from 'vue';
import App from './App.vue';
import router from './router/index';
import store from './store/index';
import VConsole from 'vconsole'
import 'lib-flexible/flexible';

if (process.env.NODE_ENV !== 'production') {
  const vconsole = new VConsole();
}

// 进度条
import 'nprogress/nprogress.css';
// 自定义全局样式
import '@/assets/style/global/index.scss';

import PAGE_API from '@/apis/pageApi';
import HTTP_API from '@/apis/httpApi';

import fn from '@/utils/fn.ts';
import Component from 'vue-class-component';


// import VConsole from 'vconsole';
// const vConsole = new VConsole();

import {
    Button, Tabbar, TabbarItem, NavBar, SwipeCell, List, PullRefresh,
    CountDown, Form, Field, DropdownMenu, DropdownItem, Toast, Cell, Sticky, Popup, Dialog,
    Tab, Tabs, IndexBar, IndexAnchor,
} from 'vant';
import { Image as VanImage } from 'vant';
Component.registerHooks([
    'beforeRouteEnter',
    'beforeRouteLeave',
    'beforeRouteUpdate',
]);

// prop全局
Vue.prototype.$fn = fn;
Vue.prototype.$PAGE_API = PAGE_API
Vue.prototype.$HTTP_API = HTTP_API

Vue.config.productionTip = false;
Vue.use(DropdownItem).use(Toast).use(Cell).use(Sticky)
    .use(Button).use(Tabbar).use(TabbarItem).use(NavBar).use(SwipeCell)
    .use(List).use(PullRefresh).use(VanImage).use(CountDown)
    .use(Form).use(Field).use(Popup).use(Dialog).use(DropdownMenu)
    .use(Tab).use(Tabs).use(IndexBar).use(IndexAnchor)



window.App = new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');
